/**
 * Util function for sending a track event when a user logs in.
 * @param {object} values The form submission values object
 */
export default function (values) {
  const {
    facebookId, email, location
  } = values;
  const method = facebookId ? 'facebook' : 'email';
  if (window && window.analytics) {
    const segmentTrackName = 'Signed In';
    const trackProperties = { method, email, location };
    window.analytics.track(segmentTrackName, trackProperties);
  }
}
